import type { TPartnerStatus } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import type { CSSProperties } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './PartnerClassList.module.scss'

type PartnerClassListProps = {
  grades: TPartnerStatus[]
}

const getClassColorStyle = (color?: string | null) =>
  color ? ({ '--partner-class-color': color } as CSSProperties) : undefined

export const PartnerClassList = ({ grades }: PartnerClassListProps) => {
  if (!grades.length) {
    return null
  }

  return (
    <div className={styles.root}>
      {grades.map((grade, index) => {
        const icon = 'Icon' in grade ? grade.Icon : ''
        const title = grade.Title?.trim()

        return (
          <Tooltip
            key={`${grade.Title}:${index}`}
            tipContent={() => <Translation text={grade.Info} span />}
          >
            <span className={styles.item} style={getClassColorStyle(grade.Color)} tabIndex={0}>
              {icon ? (
                <>
                  <i className={`${icon} ${styles.icon}`} aria-hidden />
                  <span className={styles.label}>
                    {title || <Translation text={grade.Info} span />}
                  </span>
                </>
              ) : (
                <>
                  <span className={styles.badge}>{grade.Title}</span>
                  <span className={styles.label}>
                    <Translation text={grade.Info} span />
                  </span>
                </>
              )}
            </span>
          </Tooltip>
        )
      })}
    </div>
  )
}

PartnerClassList.displayName = 'PartnerClassList'
